import { render } from "./ShimmerLoader.vue?vue&type=template&id=2a3d191c"
import script from "./ShimmerLoader.vue?vue&type=script&lang=js"
export * from "./ShimmerLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__